/**
 * Shanaya Premium Product Page Interactivity
 * Handles gallery slider, variant selection, quantity, sticky mobile ATC, FAQ accordion, and carousel navigation.
 */

function initShanayaProduct() {
  const containers = document.querySelectorAll('[data-aq-product]');
  containers.forEach(container => {
    if (container.dataset.aqInitialized) return;
    container.dataset.aqInitialized = 'true';

    // 1. Gallery Slider Interactivity
    const gallery = container.querySelector('[data-aq-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-aq-gallery-track]');
      const slides = gallery.querySelectorAll('[data-aq-slide]');
      const thumbs = gallery.querySelectorAll('[data-aq-thumb]');
      const prevBtn = gallery.querySelector('[data-aq-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-aq-gallery-next]');
      
      let currentIndex = 0;

      const updateGallery = (index) => {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;

        if (track) {
          track.style.transform = `translateX(-${currentIndex * 100}%)`;
        }

        thumbs.forEach((thumb, idx) => {
          if (idx === currentIndex) {
            thumb.classList.add('is-active');
            const scroller = thumb.parentElement;
            if (scroller) {
              const targetLeft = thumb.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
              scroller.scrollTo({
                left: targetLeft - (scroller.clientWidth / 2) + (thumb.clientWidth / 2),
                behavior: 'smooth'
              });
            }
          } else {
            thumb.classList.remove('is-active');
          }
        });
      };

      thumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', () => {
          updateGallery(idx);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          updateGallery(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          updateGallery(currentIndex + 1);
        });
      }

      gallery.updateToIndex = updateGallery;
      gallery.slides = Array.from(slides);
    }

    // 2. Variant Picker
    const variantGrid = container.querySelector('.aq-size-grid');
    const variantInput = container.querySelector('[data-aq-variant-id]');
    const mainForm = container.querySelector('form[action*="/cart/add"]');
    const stickyPrice = container.querySelector('.aq-sticky-bar .aq-sticky-price');

    let variantsData = null;
    const getVariantsData = () => {
      if (variantsData !== null) return variantsData;
      const variantJsonScript = container.querySelector('[data-aq-variants-json]');
      if (variantJsonScript) {
        try {
          variantsData = JSON.parse(variantJsonScript.textContent);
        } catch (e) {
          console.error('Failed to parse variant JSON data', e);
          variantsData = [];
        }
      } else {
        variantsData = [];
      }
      return variantsData;
    };

    if (variantGrid) {
      const sizeButtons = variantGrid.querySelectorAll('[data-aq-size]');
      sizeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          sizeButtons.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          if (variantInput) {
            variantInput.value = variantId;
          }

          const variant = getVariantsData().find(v => String(v.id) === String(variantId));
          if (variant) {
            const optionLabelVal = container.querySelector('[data-aq-selected-size]');
            if (optionLabelVal) {
              optionLabelVal.textContent = variant.name;
            }

            const priceNow = container.querySelector('[data-aq-price-now]');
            const priceWas = container.querySelector('[data-aq-price-was]');
            const priceOff = container.querySelector('[data-aq-price-off]');

            if (priceNow) {
              priceNow.textContent = variant.price_formatted;
            }

            if (variant.compare_at_price > variant.price) {
              if (priceWas) {
                priceWas.textContent = variant.compare_at_price_formatted;
                priceWas.style.display = '';
              }
              if (priceOff) {
                const offPercent = Math.round((1 - (variant.price / variant.compare_at_price)) * 100);
                const template = priceOff.dataset.offLabel || '% off';
                const pctStr = offPercent + '%';
                priceOff.textContent = template.includes('%') ? template.replace('%', pctStr) : (offPercent + ' ' + template);
                priceOff.style.display = '';
              }
            } else {
              if (priceWas) priceWas.style.display = 'none';
              if (priceOff) priceOff.style.display = 'none';
            }

            if (stickyPrice) {
              if (variant.compare_at_price > variant.price) {
                stickyPrice.innerHTML = `${variant.price_formatted} <small>${variant.compare_at_price_formatted}</small>`;
              } else {
                stickyPrice.innerHTML = variant.price_formatted;
              }
            }

            if (variant.featured_image && gallery && gallery.updateToIndex) {
              const slideIdx = gallery.slides.findIndex(slide => {
                const img = slide.querySelector('img');
                return img && img.src.includes(variant.featured_image.split('?')[0]);
              });
              if (slideIdx !== -1) {
                gallery.updateToIndex(slideIdx);
              }
            }

            // Update Add to Cart and Buy Now button states
            const atcBtn = container.querySelector('[data-aq-add-to-cart]');
            const buyNowBtn = container.querySelector('[data-aq-buy-now]');
            const stickyAdd = container.querySelector('[data-aq-sticky-add]');
            const stickyBuy = container.querySelector('[data-aq-sticky-buy]');
            if (atcBtn) {
              if (variant.available) {
                atcBtn.removeAttribute('disabled');
                atcBtn.textContent = atcBtn.dataset.labelAvailable || 'Add to cart';
              } else {
                atcBtn.setAttribute('disabled', 'disabled');
                atcBtn.textContent = atcBtn.dataset.labelSoldout || 'Sold out';
              }
            }
            if (buyNowBtn) {
              if (variant.available) {
                buyNowBtn.removeAttribute('disabled');
                buyNowBtn.textContent = buyNowBtn.dataset.labelAvailable || 'Buy Now';
              } else {
                buyNowBtn.setAttribute('disabled', 'disabled');
                buyNowBtn.textContent = buyNowBtn.dataset.labelSoldout || 'Sold out';
              }
            }
            if (stickyAdd) {
              if (variant.available) {
                stickyAdd.removeAttribute('disabled');
                stickyAdd.textContent = atcBtn ? (atcBtn.dataset.labelAvailable || 'Add to cart') : 'Add to cart';
              } else {
                stickyAdd.setAttribute('disabled', 'disabled');
                stickyAdd.textContent = atcBtn ? (atcBtn.dataset.labelSoldout || 'Sold out') : 'Sold out';
              }
            }
            if (stickyBuy) {
              if (variant.available) {
                stickyBuy.removeAttribute('disabled');
                stickyBuy.textContent = buyNowBtn ? (buyNowBtn.dataset.labelAvailable || 'Buy Now') : 'Buy Now';
              } else {
                stickyBuy.setAttribute('disabled', 'disabled');
                stickyBuy.textContent = buyNowBtn ? (buyNowBtn.dataset.labelSoldout || 'Sold out') : 'Sold out';
              }
            }
          }
        });
      });
    }

    // 3. Quantity Stepper
    const qtyWrapper = container.querySelector('[data-aq-qty]');
    if (qtyWrapper) {
      const input = qtyWrapper.querySelector('input');
      const minusBtn = qtyWrapper.querySelector('[data-aq-qty-minus]');
      const plusBtn = qtyWrapper.querySelector('[data-aq-qty-plus]');

      if (input && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', () => {
          let val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
          }
        });

        plusBtn.addEventListener('click', () => {
          let val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
        });
      }
    }

    // 4. Sticky Mobile ATC Bar click handlers
    const stickyAddBtn = container.querySelector('[data-aq-sticky-add]');
    if (stickyAddBtn && mainForm) {
      stickyAddBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof mainForm.requestSubmit === 'function') {
          mainForm.requestSubmit();
        } else {
          mainForm.submit();
        }
      });
    }

    const stickyBuyBtn = container.querySelector('[data-aq-sticky-buy]');
    if (stickyBuyBtn && mainForm) {
      stickyBuyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const primaryBuyNow = mainForm.querySelector('[data-aq-buy-now]');
        if (primaryBuyNow) {
          primaryBuyNow.click();
        } else {
          // Fallback: append a checkout input and submit
          let checkoutInput = mainForm.querySelector('input[name="checkout"]');
          if (!checkoutInput) {
            checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'checkout';
            checkoutInput.value = 'checkout';
            mainForm.appendChild(checkoutInput);
          }
          if (typeof mainForm.requestSubmit === 'function') {
            mainForm.requestSubmit();
          } else {
            mainForm.submit();
          }
        }
      });
    }
  });
}

// Global Event Delegation for Accordion (FAQ) & Carousel (Combo Offers)
// This is fully immune to editor dynamic re-renders!
document.addEventListener('click', (e) => {
  // FAQ Accordion Click Handler
  const q = e.target.closest('.accordion-q');
  if (q) {
    if (e.faqHandled) return;
    e.faqHandled = true;
    const item = q.closest('.accordion-item');
    if (item) {
      const wasOpen = item.classList.contains('open');
      const accordion = item.closest('.accordion');
      if (accordion) {
        accordion.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      }
      if (!wasOpen) {
        item.classList.add('open');
      }
    }
    return;
  }

  // Carousel Navigation Click Handler
  const carBtn = e.target.closest('.car-nav');
  if (carBtn) {
    const wrap = carBtn.closest('.carousel-wrap');
    if (wrap) {
      const track = wrap.querySelector('.carousel');
      if (track) {
        const card = track.querySelector('.product-card');
        const step = card ? card.offsetWidth + 18 : 250;
        if (carBtn.classList.contains('car-prev')) {
          track.scrollBy({ left: -step * 2, behavior: 'smooth' });
        } else if (carBtn.classList.contains('car-next')) {
          track.scrollBy({ left: step * 2, behavior: 'smooth' });
        }
      }
    }
    return;
  }
});

// Run immediately or on DomContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShanayaProduct);
} else {
  initShanayaProduct();
}

// Bind to editor events for live PDP changes inside the Shopify Customizer
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[data-aq-product]')) {
    initShanayaProduct();
  }
});
